/**
 * 관리자 설정 — 관리자 목록 (/adm/managers)
 * ($j.Pages.Admin.Managers / body data-page-name="Managers")
 *
 * 목록은 DataTables(클라이언트 검색), 조회조건(취급자·부서·권한상태)은 서버 재조회.
 * 등록·수정·이력은 JBModal — 링크는 data-mg="edit|logs" 로 부른다(window 노출 없음).
 * 부서·사유·역할 이름표는 컨트롤러가 #page-data 로 넘긴다.
 */
export default class Managers {
    initialize() { initialize(); }
}

let $table = null;
let DEPARTMENT = {}, ACTIONS = {}, CI_LEVELS = {}, GPS_LEVELS = {};

function initialize(){
    const d = JSON.parse(document.getElementById('page-data').textContent);
    DEPARTMENT = d.department || {};
    ACTIONS    = d.actions || {};
    CI_LEVELS  = d.ciLevels || {};
    // 위치정보법 역할 — 관리자 레벨과 별개 축(g5_admin_members.gps_level). 연계정보(ci_level)와 같은 모양
    GPS_LEVELS = d.gpsLevels || {};

    initPage();
    // 커스텀 검색창 → DataTables 필터
    $('#mgr-search').on('keyup', function(){ $table && $table.search(this.value).draw(); });
    // 연계정보·부서·권한상태는 서버 조회조건 → 재조회
    $('#f-ci, #f-department, #f-status').on('change', function(){ $table && $table.ajax.reload(); });
    // 수정/등록 모달에서 저장 완료 시 목록 갱신
    $j.Common.EventBus.on('adm:manager:saved', function(){ $table && $table.ajax.reload(); });
    // 등록·수정·이력 — data-mg="edit|logs" (번호는 data-n)
    $(document).on('click', '[data-mg]', function(e){
        e.preventDefault();
        const n = Number(this.dataset.n);
        if (this.dataset.mg === 'edit') editManager(n);
        else if (this.dataset.mg === 'logs') grantLogs(n);
    });
}

// 알림 아이콘 1개 렌더 (on 이면 고유색, off 면 옅은 회색 — 색은 sass 의 .c-* / .is-off)
function alarmIcon(on, icon, onCls, label){
    const cls = (on == 1) ? onCls : 'is-off';
    return `<i class="fas ${icon} mgr-alarm-ic ${cls}" title="${label}"></i>`;
}

// 앱(웹뷰) 초기화면 아이콘 — g5_admin_members.home_page.
// 켜고 끄는 값이 아니라 둘 중 하나라 아이콘 자체가 바뀐다. 기본값('m')은 다른 off 아이콘과
// 같은 옅은 회색으로 둬서, 한 줄만 봐도 '이 사람은 /ma 로 떨어진다'가 튀어 보이게 한다.
function homeIcon(home){
    const isMa = (home === 'ma');
    return `<i class="fas ${isMa ? 'fa-user-shield' : 'fa-mobile-screen'} mgr-alarm-ic ${isMa ? 'c-ma' : 'is-off'}"`
         + ` title="앱 초기화면: ${isMa ? '모바일관리자(/ma)' : '모바일 화면(/m) · 기본'}"></i>`;
}

function initPage(){
    const columns = [
        { data: 'num', title: '번호', className: 'text-center' },
        // ID 클릭 → 수정 모달
        { data: null, title: 'ID',
            render: (d, t, r) => `<a href="#" data-mg="edit" data-n="${r.num}">${r.manage_id || ''}</a>`
        },
        // 임직원명 — 아바타를 이름 앞에 붙인다. 아바타 HTML 은 서버가 그려서 내려준다
        // (얼굴을 가르는 규칙이 AdminAvatarService 한 곳에 있어야 헤더와 같은 얼굴이 나온다).
        // ID 와 같은 수정 모달로 간다 — 이름은 그 사람을 가리키는 가장 자연스러운 손잡이인데
        // 링크가 아니면 ID 나 맨 끝 [설정] 아이콘까지 눈을 옮겨야 한다.
        { data: null, title: '임직원명',
            render: (d, t, r) => `<a href="#" data-mg="edit" data-n="${r.num}" class="mgr-name">`
                               + `${r._avatar || ''}${r.manage_name || ''}</a>`
        },
        // 회원명: 이름 #회원번호 (회원번호는 작게). 누르면 회원 액션 팝오버 —
        // 기사편집만 열던 것을 관리자 어디서나 같은 팝오버로 맞춘다 ($j.F.Admin.Member.Pop).
        { data: null, title: '회원명',
            render: function (data, type, row) {
                if (!row.mb_no) return '';
                return `<a href="#" data-mb-pop="${row.mb_no}">`
                     + `${row.mem_name || ''}<span class="mgr-memno">#${row.mb_no}</span></a>`;
            }
        },
        // 앱 설정: 톡/푸시/출금 알림 + 초기화면 → 아이콘. 넷 다 같은 설정 모달에서 고친다.
        // 컬럼명을 '알림'으로 두지 않는 이유 — 초기화면은 알림이 아니다.
        { data: null, title: '앱 설정', className: 'text-center',
            render: function (data, type, row) {
                const icons = alarmIcon(row.is_talk,     'fa-comment-dots', 'c-talk', '불러톡')
                            + (row.is_talk == 1 && row.talk_vib == 1 ? '<sup class="mgr-alarm-x2" title="불러톡 진동 2번">×2</sup>' : '')
                            + alarmIcon(row.is_push,     'fa-volume-up',    'c-push', '관리자푸시')
                            + alarmIcon(row.is_exchange, 'fa-sack-dollar',  'c-exch', '출금푸시')
                            + homeIcon(row.home_page);
                return `<a href="#" data-mg="edit" data-n="${row.num}" title="알림·초기화면 설정 변경">${icons}</a>`;
            }
        },
        // 레벨은 숫자 그 자체다 — 화면 권한선(공지편집 >=7, 홀드 >=5)을 재는 눈금이라
        // 이름표를 같이 달면 위치정보법 역할(취급자 역할 칸)로 오해된다. 설명은 [역할설명] 에 있다.
        { data: 'level', title: '레벨', className: 'text-center' },
        // 부서: 뱃지
        { data: null, title: '부서', className: 'text-center',
            render: function (data, type, row) {
                const name = DEPARTMENT[row.department];
                if (!name) return '';
                return `<span class="mgr-dept mgr-dept-${row.department}">${name}</span>`;
            }
        },
        { data: null, title: '권한지정일', className: 'text-center',
            render: (d, t, r) => r.created_at ? dayjs(r.created_at).format('YYYY-MM-DD') : ''
        },
        { data: null, title: '권한말소일', className: 'text-center',
            render: (d, t, r) => r.withdraw_at ? dayjs(r.withdraw_at).format('YYYY-MM-DD') : ''
        },
        // 권한상태 — 조회조건과 짝. 목록만 캡처해도 유효/말소가 드러나야 한다.
        { data: null, title: '권한상태', className: 'text-center',
            render: function (data, type, row) {
                return row.withdraw_at
                    ? '<span class="mgr-state mgr-state-revoked">말소</span>'
                    : '<span class="mgr-state mgr-state-live">유효</span>';
            }
        },
        // 취급자 역할 — 한 사람이 위치정보·연계정보를 겸할 수 있으므로 한 칸에 모아 보여준다.
        // 두 축 다 제 컬럼(gps_level·ci_level)을 본다. 축별 상세는 취급자 탭(/adm/handlers).
        { data: null, title: '취급자 역할', className: 'text-center',
            render: function (data, type, row) {
                const badges = [];
                if (row.gps_level > 0) {
                    badges.push(`<span class="mgr-gps mgr-gps-${row.gps_level}">${GPS_LEVELS[row.gps_level]}</span>`);
                }
                if (row.ci_level > 0) {
                    badges.push(`<span class="mgr-ci mgr-ci-${row.ci_level}">${CI_LEVELS[row.ci_level]}</span>`);
                }
                return badges.length ? badges.join(' ') : '<span class="mgr-none">-</span>';
            }
        },
        // 최근 변경 요약 + 이력 진입. 변경일시·처리자 전체는 이력 모달과 취급자 탭에 있다
        // (여기까지 다 펼치면 컬럼이 과밀해져 목록으로서 못 읽는다)
        { data: null, title: '최근변경', className: 'text-center',
            render: function (data, type, row) {
                if (!row.grant_action) return '<span class="mgr-none">-</span>';
                // 정기검토 행은 사유가 없다 — 구분(정기검토)을 그대로 보여준다
                const reason = ACTIONS[row.grant_action] || row.grant_action;
                const when = row.grant_changed_at ? dayjs(row.grant_changed_at).format('YYYY-MM-DD') : '';
                return `<a href="#" data-mg="logs" data-n="${row.num}" class="mgr-reason" title="변경이력 보기">`
                     + `${reason}<span class="act">${when}</span></a>`;
            }
        },
        { data: null, title: '설정', className: 'text-center',
            render: (d, t, r) => `<a href="#" data-mg="edit" data-n="${r.num}"><i class="fa-regular fa-pen-to-square"></i></a>`
        },
    ];

    $table = new DataTable('#manager-table', {
        columns: columns,
        ajax: {
            url: '/adm/ajax/manager/list',
            type: 'post',
            // 부서·권한상태는 서버에서 거른다 (조회결과 건수가 심사 증빙이 되므로)
            data: function (d) {
                d.ci         = $('#f-ci').val();
                d.department = $('#f-department').val();
                d.status     = $('#f-status').val();
            },
        },
        processing: true,
        serverSide: false,
        ordering: false,
        displayLength: 30,
        lengthChange: false,
        searching: true,     // 검색 API 활성화 (기본 검색창은 layout 에서 제거, 커스텀 사용)
        layout: {
            topStart: null,
            topEnd: null,
            bottomStart: 'info',
            bottomEnd: 'paging',
        },
        // 탈퇴자 라인 흐리게
        createdRow: function (row, data) {
            if (data.withdraw_at) $(row).addClass('mgr-withdrawn');
        },
        // 조회결과 건수 (검색어까지 반영된 실제 표시 건수)
        drawCallback: function (settings) {
            $('#f-count').text(this.api().rows({ search: 'applied' }).count());
        },
    });

    // 회원명 클릭 → 회원 액션 팝오버. 위임이라 한 번만 걸면 다시 그려도 산다
    $j.F.Admin.Member.Pop.bind('#manager-table');
}

// 등록/수정 모달 열기
function editManager(n){
    const param = n >= 0 ? { num: n } : null;
    $j.Ui.JBModal.open('jb-modal-manager', '/adm/ajax/manager/edit', param, { title: '관리자 등록/수정', onOpen: () => $j.F.Admin.ManagerEditForm.init() });
}

// 권한 변경이력 모달 열기
function grantLogs(n){
    $j.Ui.JBModal.open('jb-modal-grant-logs', '/adm/ajax/manager/grant-logs', { num: n }, { title: '권한 변경이력' });
}
